/* Shipping timeline block: fills [start_date] / [end_date] tokens with dates
   computed in the visitor's timezone. Loaded only on pages that use the block. */
(function () {
  if (window.customElements && customElements.get('shipping-timeline')) return;
  if (!window.customElements) return;

  customElements.define(
    'shipping-timeline',
    class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(this.render.bind(this));
      }

      formatDate(date, format, days, months) {
        var d = date.getDate();
        var monthIndex = date.getMonth();
        var m = months[monthIndex] || '';
        var weekday = days[(date.getDay() + 6) % 7] || '';

        switch (format) {
          case 'dm_slash':
            return d + '/' + (monthIndex + 1);
          case 'month_day':
            return m + ' ' + d;
          case 'weekday_day_month':
            return weekday + ' ' + d + ' ' + m;
          default:
            return d + ' ' + m;
        }
      }

      render() {
        var months = (this.getAttribute('data-month-labels') || '').split(',').map(function (s) { return s.trim(); });
        var days = (this.getAttribute('data-day-labels') || '').split(',').map(function (s) { return s.trim(); });
        var format = this.getAttribute('data-date-format') || 'day_month';
        var today = new Date();
        var self = this;

        this.querySelectorAll('[data-checkpoint]').forEach(function (cp) {
          var min = parseInt(cp.getAttribute('data-min') || '0', 10);
          var max = parseInt(cp.getAttribute('data-max') || '0', 10);
          if (isNaN(min)) min = 0;
          if (isNaN(max)) max = 0;

          var start = new Date(today);
          start.setDate(start.getDate() + min);
          var end = new Date(today);
          end.setDate(end.getDate() + max);

          var startStr = self.formatDate(start, format, min, months);
          var endStr = self.formatDate(end, format, max, months);

          ['top', 'bottom'].forEach(function (pos) {
            var el = cp.querySelector('[data-cp-' + pos + ']');
            if (!el) return;
            var tpl = el.getAttribute('data-text') || '';
            el.innerHTML = tpl.replace(/\[start_date\]/g, startStr).replace(/\[end_date\]/g, endStr);
          });
        });
      }
    }
  );
})();
